import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { cloneDeep, isObject } from '@/global/utils/utils'
import { api } from '@/global/services/api'
import { dateService, FORMATS } from '@/global/services/date'

export default {
  methods: {
    onShowServiceIntervalDetails (event) {
      const { setFormData, getFormData } = registeredTabsHandlers?.serviceIntervals || {}
      const { data } = event || {}
      const clonedData = cloneDeep(data)
      const { showDetails, setDetailsTitle, configDynamicFields } = this.blockConfig || {}
      const appendToDetailsTitle = this.$t(clonedData?.type?.description || '') || this.$t('fleet/vehicle.details')
      const detailsTitle = this.$t('fleet/vehicle_service.interval') + ' - ' + appendToDetailsTitle

      if (typeof setFormData === 'function' && data && isObject(data)) {
        // convert dates for correct display
        clonedData.input_date = clonedData?.input_date ? dateService.formatCustom(data.input_date, FORMATS.isoDate, FORMATS.date) : null
        if (clonedData?.type?.name === 'date') {
          clonedData.start_state = clonedData?.start_state ? dateService.formatCustom(data.start_state, FORMATS.isoDate, FORMATS.date) : null
        }

        setDetailsTitle?.(detailsTitle)
        this.serviceIntervalsDetailsTitle = detailsTitle
        setFormData(clonedData)
      }

      if (typeof getFormData === 'function') {
        const data = getFormData()
        configDynamicFields?.(data)
        this.configDynamicFields?.(data?.data?.type?.name || null)
      }

      showDetails?.()
      this.showServiceIntervalsTable = false
      this.showServiceIntervalsDetails = true
    },

    onIntervalDelete (event) {
      const { id, name } = event?.data || {}
      if (!id) {
        return
      }

      const title = this.$t('fleet/vehicle.interval_delete_title')
      this.$set(this.informationDialogConfig, 'title', title + ' - ' + (name || '/'))
      this.$set(this.informationDialogConfig, 'message', this.$t('fleet/vehicle.interval_delete_message'))
      this.$set(this.informationDialogConfig, 'callbackFn', () => this.intervalDelete(event))
      this.$set(this.informationDialogConfig, 'openDialog', true)
    },

    async intervalDelete (event) {
      try {
        const { id } = event?.data || {}
        const { fetchData } = registeredTableHandlers?.serviceIntervals || {}

        await api('fleet').delete(`vehicle-service/${id}`)

        this.$set(this.informationDialogConfig, 'openDialog', false)
        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onArchiveServiceInterval (event) {
      const { id, type } = event?.data || {}
      if (id) {
        this.archiveId = id
        this.archiveType = type
        this.$set(this.archiveIntervalDialogConfig, 'openDialog', true)
      }
    },

    async archiveServiceInterval () {
      try {
        if (!this.archiveId) {
          return
        }

        if (!this.archiveFormData.start_state) {
          this.$set(this.archiveValidationErrors, 'start_state', this.$t('fleet/vehicle.interval_start_state_missing'))
          return
        }
        else if (!this.archiveFormData.note) {
          this.$set(this.archiveValidationErrors, 'note', this.$t('fleet/vehicle.interval_note_missing'))
          return
        }

        const formData = new FormData()
        formData.append('_method', 'PATCH')
        formData.append('start_state', this.archiveFormData.start_state)
        formData.append('note', this.archiveFormData.note)

        await api('fleet').post(`vehicle-service-archive/${this.archiveId}`, formData)
        this.$set(this.archiveIntervalDialogConfig, 'openDialog', false)
        this.archiveId = null
        const { fetchData } = registeredTableHandlers?.serviceIntervals || {}
        fetchData?.()
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onIntervalArchiveDataUpdate (data) {
      this.archiveFormData = cloneDeep(data)
    }
  }
}
